import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FichaDaObraService } from 'src/app/ficha-da-obra/service/ficha-da-obra.service';
import { environment } from 'src/environments/environment';
import { SucessoComponent } from '../../sucesso/sucesso.component';

@Component({
  selector: 'app-editar-relato',
  standalone: true,
  imports: [CommonModule, FormsModule, SucessoComponent],
  templateUrl: './editar-relato.component.html',
  styleUrls: ['./editar-relato.component.scss'],
})
export class EditarRelatoComponent implements OnInit {
  @Input() relato: any;
  @Output() close = new EventEmitter<void>();
  @Output() relatoEditado = new EventEmitter<void>();

  @Output() loading = new EventEmitter<boolean>();
  @Input() idObra: number | null = null;

  BASE_IMG_URL: string = environment.BASE_IMG_URL;
  sucesso = false;

  descricao: string = '';
  titulo: string = '';
  responsavel: any[] = [];
  selectedResponsaveis: any[] = [];
  enviarEmail = false;

  private _fichaDaObraService = inject(FichaDaObraService);

  constructor() {}

  ngOnInit() {
    this.descricao = this.relato?.descricao || '';
    this.titulo = this.relato?.titulo || '';
    this.enviarEmail = this.relato?.enviarEmail || false;
    this.selectedResponsaveis = this.relato?.responsaveis || [];
    this.popularResponsavelObra();
  }

  popularResponsavelObra(): void {
    this._fichaDaObraService.popularResponsavelObra().subscribe(
      (response) => {
        this.responsavel = response.data;
      },
      (error) => {}
    );
  }

  editarRelato() {
    this.loading.emit(true);
    if (!this.relato?.raw || !this.idObra) {
      console.error(
        'Erro: Propriedade raw ou ID da obra ausentes no relato:',
        this.relato
      );
      return;
    }

    const body: any = {
      title: this.titulo,
      text: this.descricao,
      textTypeID:
        this.enviarEmail && this.selectedResponsaveis.length > 0 ? 2 : 1,
      sendEmailContactIDs: this.enviarEmail
        ? this.selectedResponsaveis.length > 0
          ? this.selectedResponsaveis.map((r: any) => r.id).join(',')
          : '0'
        : null,
      isEdited: true,
      reportID: this.relato.raw.reportID,
    };

    this._fichaDaObraService.novoRelato(this.idObra, body).subscribe({
      next: () => {
        this.sucesso = true;
        this.relato.raw.source = 'editar-relato';
        this.relatoEditado.emit();

        this.loading.emit(false);
      },
      error: (err) => {
        console.error('Erro ao editar relato:', err);
        this.loading.emit(false);
      },
    });
  }

  criarRelato() {
    if (!this.relato?.raw || !this.idObra) {
      console.error(
        'Erro: Propriedade raw ou ID da obra ausentes no relato:',
        this.relato
      );
      return;
    }

    const sendEmailContactIDs =
      this.enviarEmail && this.selectedResponsaveis.length > 0
        ? this.selectedResponsaveis.map((r: any) => Number(r.id))
        : null;
    const body: any = {
      title: this.titulo,
      text: this.descricao,
      sendEmailContactIDs,
    };

    this._fichaDaObraService.novoRelato(this.idObra, body).subscribe({
      next: () => {
        this.relato.raw.source = 'criar-relato';
        this.relatoEditado.emit();
      },
      error: (err) => {
        console.error('Erro ao criar relato:', err);
      },
    });
  }

  continuar() {
    this.sucesso = false;
    this.close.emit();
  }

  clear() {
    this.descricao = '';
    this.titulo = '';
    this.enviarEmail = false;
    this.selectedResponsaveis = [];
  }

  isSelected(responsavel: any): boolean {
    return this.selectedResponsaveis.some((r) => r.id === responsavel.id);
  }

  toggleSelection(responsavel: any) {
    if (this.isSelected(responsavel)) {
      this.selectedResponsaveis = this.selectedResponsaveis.filter(
        (r) => r.id !== responsavel.id
      );
    } else {
      this.selectedResponsaveis.push(responsavel);
    }
  }

  toggleSelectAll(event: any) {
    if (event.target.checked) {
      this.selectedResponsaveis = [...this.responsavel];
    } else {
      this.selectedResponsaveis = [];
    }
  }
}
